import script from "./ChatMessageSender.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatMessageSender.vue?vue&type=script&setup=true&lang=ts"

import "./ChatMessageSender.vue?vue&type=style&index=0&id=12c9ac72&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c9ac72"]])

export default __exports__